import a, { useState as l, useEffect as u, Fragment as f } from "react";
import d from "react-dom";
const t = {
  checkout: { isOpen: !1, content: null, containerId: "checkout-fixed-container" },
  commenter: { isOpen: !1, content: null, containerId: "comment-fixed-container" },
  confirm: { isOpen: !1, content: null, containerId: "confirm-fixed-container" },
  diagnosisLoader: { isOpen: !1, content: null, containerId: "diagnosis-loading-fixed-container" },
  resetAlert: { isOpen: !1, content: null, containerId: "reset-alert-fixed-container" },
  snackbar: { isOpen: !1, content: null, containerId: "snackbar-fixed-container" }
}, r = /* @__PURE__ */ new Set(), i = () => {
  r.forEach((e) => e());
};
class m {
  #n;
  /**
   * @param {string} portalKey - Key to identify this portal in global state
   */
  constructor(n) {
    this.#n = n;
  }
  /**
   * @param {React.ReactNode} children
   */
  render(n) {
    t[this.#n] && (t[this.#n].isOpen = !0, t[this.#n].content = n, i());
  }
  unmount() {
    t[this.#n] && (t[this.#n].isOpen = !1, t[this.#n].content = null, i());
  }
}
const g = () => {
  const [, e] = l({});
  return u(() => {
    const n = () => e({});
    return r.add(n), () => r.delete(n);
  }, []), a.createElement(
    f,
    {},
    Object.entries(t).map(([n, c]) => {
      if (!c.isOpen || !c.content) return null;
      const s = document.getElementById(c.containerId);
      return s ? d.createPortal(
        c.content,
        s,
        n
      ) : null;
    })
  );
};
function o(e) {
  return new m(e);
}
const O = o("checkout"), p = o("commenter"), R = o("confirm"), h = o("diagnosisLoader"), E = o("resetAlert"), I = o("snackbar"), C = () => {
  O.unmount();
}, k = () => {
  p.unmount();
}, A = () => {
  R.unmount();
}, S = (e) => {
  h.unmount();
}, x = () => {
  E.unmount();
}, L = () => {
  I.unmount();
};
export {
  O as CHECKOUT_ROOT,
  p as COMMENTER_ROOT,
  R as CONFIRM_ROOT,
  h as DIAGNOSIS_LOADER_ROOT,
  g as PortalManager,
  E as RESET_ALERT_ROOT,
  I as SNACKBAR_ROOT,
  C as closeCheckout,
  k as closeCommenter,
  A as closeConfirm,
  S as closeDiagnosisLoader,
  x as closeResetAlert,
  L as closeSnackBar
};
